<div [formGroup]="linkForm" nz-form nzLayout="horizontal" class="media-link-modal">
  <nz-form-item>
    <nz-form-label [nzSpan]="6" nzRequired>Link Name</nz-form-label>
    <nz-form-control [nzSpan]="18">
      <input nz-input placeholder="Name" formControlName="name" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="6" nzRequired>Link URL</nz-form-label>
    <nz-form-control [nzSpan]="18">
      <input nz-input placeholder="URL" formControlName="url" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="6" nzRequired>Link Type</nz-form-label>
    <nz-form-control [nzSpan]="18">
      <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select Type" formControlName="type">
        <nz-option nzValue="1" nzLabel="Google Drive"></nz-option>
        <nz-option nzValue="2" nzLabel="Others"></nz-option>
      </nz-select>
    </nz-form-control>
  </nz-form-item>

  <div class="modal-footer" style="text-align: right; margin-top: 16px;">
    <button nz-button (click)="handleCancel()">Cancel</button>
    <button nz-button nzType="primary" [disabled]="!linkForm.valid" (click)="addLink()">Save</button>
  </div>
</div>
